import { invoke } from '@forge/bridge';

import { IncidentBannerSaveDto, IncidentBannerStatus, IncidentPortalBannerDto } from '../../../src/common/model';

export const saveIncidentBanner = (banner: IncidentBannerSaveDto) =>
	invoke('save-incident-banner', {banner});

export const updateIncidentBanner = (key: string, banner: IncidentBannerSaveDto) =>
	invoke('update-incident-banner', {key, banner});

export const deleteIncidentBanner = (key: string, projectId: string) =>
	invoke('delete-incident-banner', {key, projectId});

export const getBannersForProjectAndStatus = (projectId: string, status: IncidentBannerStatus) =>
	invoke('get-incident-banners-for-project-and-status', {projectId, status});

export const getBannersForServicedesk = (servicedeskId: string | number) =>
	invoke<IncidentPortalBannerDto[]>('get-incident-banners-for-servicedesk', {serviceDeskId: servicedeskId.toString()});
